import { getSessionId } from '@/lib/trackerSession'; // one tracker id, created if missing (lead ↔ visit, Founder 2026-09-27)
// Shared conversion-tracking calls, used both by ContactModal (first contact,
// via the verification modal) and by the contact buttons directly (repeat
// clicks on an already-contacted pro, which skip the modal entirely) — see
// components/ContactModal.tsx and lib/contactedState.ts.
import { getClickIds } from '@/components/Tracker';
import { SMART_INTAKE_KEY } from '@/components/SmartIntakeBar';
import type { ContactIntent } from './waMessage';

// "Simple" conversion — a message/call button was clicked. No value.
export function fireContactIntent(proId: number | undefined, proName: string, categorySlug: string | undefined, intent: ContactIntent) {
  const ids = getClickIds();
  try {
    window.gtag?.('event', 'contact_click_intent', { pro_id: proId, category: categorySlug, intent });
  } catch {}
  let sid: string | null = null;
  try { sid = getSessionId(); } catch {}
  fetch('/api/contact/intent', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionId: sid, proId, proName, categorySlug, intent, ...ids }),
  }).catch(() => {});
}

// "Real" conversion for the wa-first flow (2026-07-31) — a visitor actually activated
// the tracked tel:/wa.me link, fired session-based rather than against a verified-user
// token (the OTP identity this used to key off, via the now-removed /api/contact/confirm
// — see docs/archive/otp-verification-2026-09-09/ — no longer exists). See
// app/api/contact/wa-confirm/route.ts for the server side.
export function fireWaConfirm(opts: {
  proId: number | undefined; proName: string; categorySlug: string | undefined;
  categoryName?: string | null; intent: ContactIntent; waMessage?: string | null;
}) {
  const ids = getClickIds();
  try {
    window.gtag?.('event', 'contact_verified_click', { pro_id: opts.proId, category: opts.categorySlug, intent: opts.intent });
  } catch {}
  let sessionId: string | null = null;
  try {
    const saved = localStorage.getItem(SMART_INTAKE_KEY);
    if (saved) sessionId = JSON.parse(saved)?.sessionId ?? null;
  } catch {}
  let trackerSessionId: string | null = null;
  try { trackerSessionId = getSessionId(); } catch {}
  fetch('/api/contact/wa-confirm', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true, // 02/10: fired right before location → wa.me; without keepalive the navigation cancels it
    body: JSON.stringify({ ...opts, sessionId, trackerSessionId, ...ids }),
  }).catch(() => {});
}
